import React, { useMemo, useRef } from "react";
import "./styles.css";
import { MODULE_TYPES } from "../../Library/widgets";
import { useNavigate } from "react-router-dom";
import { Title, WidgetLegend } from "../../Components/Atoms";
import { Button } from "@chakra-ui/react";
import { ArrowRightIcon } from "../../Assets/images/svgs";
import PATHS from "../../Routes/paths";
import { Donut } from "../../Components/Organisms/Graphs";

const OemDevices = ({ data, enums, label, title }) => {
  let count = useRef(0);

  const parser = { x: "label", y: "count" };
  const graphData = useMemo(() => {
    count.current = 0;
    return data.map(d => {
      count.current += d.cnt;
      const status = enums[d.idx];
      return { label: d.nm, count: d.cnt, color: status.color };
    });
  }, [ data, enums ]);

  return (
    <main className="widget-section dealers-device-count-widget">
      <header className="widget-header">
        <p className="widget-heading">{title}</p>
      </header>
      <div className="widget-chart dealers-device-chart">
        <Donut title="Devices" data={graphData} parser={parser} cutout={68} />
        <p className="widget-chart-icon">
          <span className="devices-count">{count.current}</span>
          <span className="dev-count-label">{label}</span>
        </p>
      </div>
      <div className={`widget-legend device-stats ${graphData.length <= 1 ? "justify-widget-legends" : ""}`}>
        <WidgetLegend sparse data={graphData} parser={parser} showCount={false} showPercent={false} doSort={false} />
      </div>
    </main>
  )
}

const DealershipDevices = (stats) => {
  const navigate = useNavigate();
  const dataFor = stats.data && stats.data[MODULE_TYPES.ALL_DEVICES] ? stats.data[MODULE_TYPES.ALL_DEVICES] : {};
  const { one, two, three, count } = dataFor;

  const colors = [
    "rgba(253, 160, 20, 1)",
    "rgba(106, 157, 255, 1)",
    "rgba(252, 220, 138, 1)",
    "rgba(202, 202, 202, 1)",
    // "rgba(236, 105, 105, 1)",
    // "rgba(202, 202, 202, 1)",
  ];

  const titleMap = {};
  const mapDevicesToEnum = (devices, key) => {
    if (!devices || !devices.length) return;

    return devices.reduce((acc, dev, idx) => {
      if (!titleMap[key]) titleMap[key] = dev.oem;
      acc[dev.idx] = { idx: dev.idx, mk: dev.mk, label: dev.nm, color: colors[idx], oem: dev.oem, cnt: dev.cnt };
      return acc;
    }, {});
  }

  const enumsOne = mapDevicesToEnum(one, "one");
  const enumsTwo = mapDevicesToEnum(two, "two");
  const enumsThree = mapDevicesToEnum(three, "three");

  return (
    <>
      {((one && one.length) || (two && two.length) || (three && three.length)) && <div className="widget-group widget-2 dealers-device-count oem-chart">
        <article className="widget-main">
          <header className="chart-widgets-group-header">
            <Title variant="md" fixed>{`Dealerships ${count ? ` (${count})` : ""}`}</Title>
          </header>
          <div className="widget-group widget-1">
            {(three && three.length) ? <OemDevices label={"Devices"} title={"Devices not mapped"} data={three} enums={enumsThree} /> : null}
            <div className="widget-seperator" />
            {(two && two.length) ? <OemDevices label={"Devices"} title={"Devices mapped"} data={two} enums={enumsTwo} /> : null}
            <div className="widget-seperator" />
            {(one && one.length) ? <OemDevices label={"Devices"} title={"Total devices"} data={one} enums={enumsOne} /> : null}
          </div>
        </article>

        <div className="widget-link device-count-widget-link">
          <Button variant={"ghost"} rightIcon={<ArrowRightIcon />} onClick={() => navigate(PATHS.SHOW_DEALERS)}>
            View Reports
          </Button>
        </div>
      </div>}
    </>
  )
}

export default DealershipDevices
